import React from 'react';
import PropTypes from 'prop-types';

import { GaugeNFL as Gauge } from '../Graphics/GaugeV3';
import { fixDecimals } from '../../../helpers/helpers';
import './SpeedMetric.scss';
import { SppedMetric } from '../types';

const speedMetric = ({ label, current, target, max, compare, height, width, left, top } : SppedMetric) => {
  return (
    <div className="g-b speed">
      <div className="g-l">
        {label}
      </div>
      <div
        className="test"
        style={{ height: `${height}%`, width: `${width}%`, position: 'absolute', left: `${left}px`, top: `${top}px` }}
      >
        <div className="g-r">
          <Gauge
            maxVel={max}
            curVel={current}
            previousVel={target * 100}
            targetVel={undefined}
            compareFlag={compare}
            popupFlag={false}
          />
          <div className="gauge-percentage">{fixDecimals(target * 100,1)}%</div>
        </div>
      </div>
    </div>
  );
};

speedMetric.propTypes = {
  label: PropTypes.string,
  flag: PropTypes.bool
};

export default speedMetric;
